<template>
  <section class="hero">
    <div 
      class="hero-background" 
      :class="{ 'has-image': backgroundImage }"
      :style="backgroundImage ? { 
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      } : {}"
    ></div>
    <div class="hero-container">
      <div class="hero-content">
        <div class="hero-text">
          <p class="hero-subtitle">Conocimiento al servicio de tu aprendizaje</p>
          <h1 class="hero-title">¡Bienvenidos a Bibliotecas AIEP!</h1>
          <button class="btn btn-secondary" @click="openVideoGuide">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_40002132_2958)">
                <path d="M12 22.2857C6.32571 22.2857 1.71429 17.6743 1.71429 12C1.71429 6.32571 6.32571 1.71429 12 1.71429C17.6743 1.71429 22.2857 6.32571 22.2857 12C22.2857 17.6743 17.6743 22.2857 12 22.2857ZM12 0C5.38286 0 0 5.38286 0 12C0 18.6171 5.38286 24 12 24C18.6171 24 24 18.6171 24 12C24 5.38286 18.6171 0 12 0ZM16.3714 12.7029C15.7886 13.2086 10.6629 16.0114 9.84 16.2686C9.14571 16.5 8.86286 16.1057 8.76 15.9429C8.64 15.7029 8.58 15.4457 8.58 15.18V8.81999C8.58 8.56285 8.64857 8.29714 8.76 8.05714C8.86286 7.88571 9.14571 7.50857 9.84 7.72285C10.6629 7.98857 15.7886 10.7829 16.3714 11.2886C16.6114 11.4943 16.7229 11.7171 16.7229 11.9914C16.7229 12.2657 16.6114 12.4886 16.3714 12.6943V12.7029ZM10.3629 6.09429C9.10286 5.69143 7.91143 6.12 7.26 7.21714C7.26 7.21714 7.26 7.23428 7.26 7.24285L7.24286 7.26C6.99429 7.74 6.86571 8.27999 6.86571 8.81999V15.18C6.86571 15.72 6.99429 16.26 7.24286 16.74C7.24286 16.7486 7.25143 16.7571 7.26 16.7657V16.7829C7.26 16.7829 7.32 16.86 7.34571 16.9029C7.34571 16.92 7.36286 16.9286 7.38 16.9457C7.86857 17.6571 8.60571 18.06 9.43714 18.06C9.73714 18.06 10.0457 18.0086 10.3543 17.9143C11.2886 17.6143 16.6629 14.7257 17.4857 14.0057C18.1029 13.4743 18.42 12.78 18.42 12.0086C18.42 11.2371 18.0943 10.5429 17.4857 10.0114C16.6629 9.29142 11.2886 6.40285 10.3543 6.10285H10.3714L10.3629 6.09429Z" fill="#024588"/>
              </g>
              <defs>
                <clipPath id="clip0_40002132_2958">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            Ver guía rápida de uso
          </button>
        </div>
        <div class="hero-mobile-titles">
          <p class="hero-mobile-subtitle">Conocimiento al servicio de tu aprendizaje</p>
          <h2 class="hero-mobile-title">Accede a libros y recursos digitales</h2>
        </div>
        <div class="hero-widget">
          <div class="widget-tabs-wrapper">
            <div class="widget-tabs">
              <button 
                :class="['tab', { active: activeTab === 'fisicos' }]"
                @click="activeTab = 'fisicos'"
              >
                Libros por sede
              </button>
              <!-- <button 
                :class="['tab', { active: activeTab === 'digitales' }]"
                @click="activeTab = 'digitales'"
              >
                Libros digitales
              </button> -->
            </div>
          </div>
          <div class="widget-divider"></div>
          <h3 class="widget-title">
            <span class="widget-title-desktop">Accede a libros y recursos digitales</span>
            <span class="widget-title-mobile">{{ activeTab === 'fisicos' ? 'Accede a libros y recursos digitales' : 'Accede a libros y recursos digitale' }}</span>
          </h3>
          <p class="widget-description">
            <span class="widget-description-desktop">Descubre lecturas y materiales que facilitan tu estudio.</span>
            <span class="widget-description-mobile">{{ activeTab === 'fisicos' ? 'Descubre lecturas y materiales que facilitan tu estudio.' : 'Descubre lecturas  materiales digitales que facilitan tu estudio' }}</span>
          </p>
          <!-- Formulario oculto Muse Knowledge -->
          <form
            ref="museForm"
            method="post"
            action="https://itms.museknowledge.com/muse/servlet/MusePeer"
            target="_blank"
            style="display:none"
          >
            <input type="text" name="queryStatement" :value="searchQuery" />
            <input type="hidden" name="action" value="logon" />
            <input type="hidden" name="userID" value="ashGA959D8ko8XDXeNBy9odqyt8ayY" />
            <input type="hidden" name="userPwd" value="ab89b1bced6f16056aa0b985e72b338e596e184c4186cb8791d7f9aeb0f29f126094597c365f49f3f969cefb1f14acad28b2cd62fcf9d14b5ddc8830fd337fdd01273994f3ecad86cdcf15804a115ad53d73d826b51c78fb" />
            <input type="hidden" name="encryption" value="DES" />
            <input type="hidden" name="templateFile" value="passThrough.html" />
            <input type="hidden" name="errorTemplate" value="logon/AIEP/error.html" />
            <input type="hidden" name="reuseSession" value="true" />
          </form>

          <div class="search-container">
            <div class="search-box">
              <input 
                v-model="searchQuery"
                type="text" 
                class="search-input" 
                placeholder="Busca por título, autor y más"
                @keyup.enter="handleSearch"
              />
            </div>
            <button class="search-btn" @click="handleSearch">
              <span class="search-btn-text">Buscar</span>
              <svg class="search-btn-desktop-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1032_6495)">
                  <path d="M2.01027 7.16752C2.01027 4.32263 4.32226 2.0104 7.16685 2.0104C10.0114 2.0104 12.3234 4.32263 12.3234 7.16752C12.3234 10.0124 10.0114 12.3246 7.16685 12.3246C4.32226 12.3246 2.01027 10.0124 2.01027 7.16752ZM15.0167 14.1647L12.0692 11.217C12.9771 10.1153 13.5278 8.70498 13.5278 7.16752C13.5278 3.6568 10.6712 0.799805 7.1608 0.799805C3.65045 0.799805 0.799805 3.6568 0.799805 7.16752C0.799805 10.6782 3.6565 13.5352 7.16685 13.5352C8.70414 13.5352 10.1143 12.9844 11.2159 12.0765L14.1633 15.0243C14.2844 15.1453 14.4357 15.1998 14.5931 15.1998C14.7504 15.1998 14.9017 15.1393 15.0228 15.0243C15.2588 14.7882 15.2588 14.4069 15.0228 14.1708H15.0167V14.1647Z" fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0_1032_6495">
                    <rect width="16" height="16" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </button>
            <div class="search-input-group">
              <input 
                v-model="searchQuery"
                type="text" 
                class="search-input search-input-mobile" 
                placeholder="Busca por título, autor y más"
                @keyup.enter="handleSearch"
              />
              <button class="search-btn search-btn-mobile" @click="handleSearch">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.764 9.85522C2.764 5.94349 5.94298 2.76417 9.8543 2.76417C13.7656 2.76417 16.9446 5.94349 16.9446 9.85522C16.9446 13.7669 13.7656 16.9463 9.8543 16.9463C5.94298 16.9463 2.764 13.7669 2.764 9.85522ZM20.6479 19.4764L16.5951 15.4232C17.8434 13.9084 18.6007 11.9692 18.6007 9.85522C18.6007 5.02798 14.6727 1.09961 9.84598 1.09961C5.01925 1.09961 1.09961 5.02798 1.09961 9.85522C1.09961 14.6825 5.02757 18.6108 9.8543 18.6108C11.9681 18.6108 13.9071 17.8535 15.4217 16.605L19.4745 20.6583C19.6409 20.8247 19.849 20.8996 20.0653 20.8996C20.2817 20.8996 20.4898 20.8164 20.6562 20.6583C20.9807 20.3337 20.9807 19.8093 20.6562 19.4847H20.6479V19.4764Z" fill="white"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="floating-btn" @click="navigateToBibliografia">
      <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.3292 5.30168C15.6865 5.70653 14.8383 6.15637 13.8036 6.64477C12.3127 7.35166 10.9954 7.87861 9.87719 8.19993C9.61371 8.27704 9.31168 8.32203 8.99679 8.34131C8.6819 8.32203 8.37986 8.27704 8.11639 8.19993C6.99822 7.87219 5.68083 7.35166 4.18993 6.64477C3.16173 6.15637 2.31346 5.70653 1.67083 5.30168C1.61942 5.26955 1.53588 5.21171 1.45234 5.14102C1.31096 5.02535 1.28526 4.8904 1.28526 4.81328C1.28526 4.73617 1.30453 4.59479 1.45234 4.47912C1.55516 4.402 1.6387 4.33774 1.70296 4.29918C2.34559 3.90075 3.18101 3.45734 4.18993 2.97537C5.68083 2.26848 6.99822 1.74152 8.11639 1.42021C8.37986 1.34309 8.6819 1.29811 8.99679 1.27883C9.31168 1.29811 9.61371 1.34309 9.87719 1.42021C10.9954 1.74795 12.3127 2.26848 13.8036 2.97537C14.819 3.45734 15.6544 3.90075 16.2906 4.29918C16.3549 4.33774 16.4384 4.402 16.5412 4.47912C16.689 4.59479 16.7083 4.73617 16.7083 4.81328C16.7083 4.8904 16.689 5.02535 16.5412 5.14102C16.4513 5.21171 16.3742 5.26955 16.3227 5.30168H16.3292ZM13.1289 11.4645C11.9979 11.9786 10.9568 12.3834 10.0186 12.6726C9.7101 12.769 9.35666 12.8268 8.99679 12.8461C8.63692 12.8268 8.27704 12.769 7.97501 12.6726C7.03677 12.3834 5.98929 11.9786 4.86469 11.4645C4.6462 11.3617 4.49839 11.1367 4.49839 10.8861V8.19993C5.70653 8.73974 6.799 9.15744 7.75652 9.4402C8.12924 9.54945 8.53409 9.61371 8.96466 9.63299H9.02892C9.45948 9.61371 9.86434 9.54302 10.2371 9.4402C11.1946 9.16387 12.287 8.73974 13.4888 8.20636V10.8861C13.4888 11.1367 13.3474 11.3681 13.1225 11.4645H13.1289ZM18 4.81971C18 4.29275 17.7558 3.80436 17.3381 3.47662C17.1903 3.36094 17.0618 3.27098 16.9718 3.21314C16.2906 2.789 15.4166 2.32631 14.3563 1.82506C12.8076 1.08604 11.4195 0.539808 10.2371 0.199215C9.86434 0.0899688 9.45948 0.0257051 9.02892 0H8.96466C8.53409 0.0192788 8.12924 0.0899688 7.75652 0.199215C6.57408 0.546234 5.19243 1.09247 3.63727 1.83149C2.58336 2.33274 1.70296 2.80186 1.02178 3.22599C0.93181 3.28383 0.803285 3.3738 0.661906 3.48947C0.237772 3.81721 0 4.30561 0 4.83256C0 5.35952 0.237772 5.84149 0.661906 6.16923C0.790432 6.27205 0.906105 6.35559 0.989647 6.407C1.58086 6.77972 2.33274 7.18458 3.21314 7.61514V10.899C3.21314 11.6508 3.65013 12.3385 4.33131 12.6469C5.50732 13.1803 6.60621 13.6044 7.59586 13.9129C8.01999 14.0414 8.47626 14.1185 8.95823 14.1442H9.02249C9.51089 14.1185 9.96716 14.0414 10.3913 13.9129C11.3809 13.6109 12.4798 13.1803 13.6558 12.6469C14.337 12.3385 14.774 11.6508 14.774 10.899V7.61514C15.5195 7.24884 16.1621 6.90825 16.7019 6.58693V11.5737C16.7019 11.9272 16.9911 12.2164 17.3445 12.2164C17.698 12.2164 17.9871 11.9272 17.9871 11.5737V4.90968C17.9871 4.90968 17.9936 4.85827 17.9936 4.83256V4.81971H18Z" fill="white"/>
      </svg>
      <span class="floating-btn-text">
        <span>Revisa la bibliografía</span>
        <span>de tus asignaturas</span>
      </span>
    </button>

    <transition name="fade">
      <div v-if="showVideoGuide" class="video-modal-backdrop">
        <div class="video-modal">
          <button class="video-modal-close" @click="closeVideoGuide">×</button>
          <div class="video-modal-content">
            <video
              width="600"
              height="340"
              controls
              autoplay
              muted
              playsinline
            >
              <source
                src="https://bibliotecas.aiep.cl/client/es_CL/search/stream.mediaplayer:streamfile/4404/0"
                type="video/mp4"
              />
              Tu navegador no soporta la etiqueta de video.
            </video>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import strapiService from '../../services/strapi'

let backgroundImageDesktop = null
let backgroundImageMobile = null

try {
  backgroundImageDesktop = require('@/assets/images/hero-background.jpg')
} catch (e) {
  // Imagen de fondo desktop no encontrada
}

try {
  backgroundImageMobile = require('@/assets/images/b1b818e26d255f001e62b637fce22a3221cf95c6.jpg')
} catch (e) {
  // Imagen de fondo mobile no encontrada
}

export default {
  name: 'HeroSection',
  data() {
    return {
      activeTab: 'fisicos',
      searchQuery: '',
      searchFilter: '', // Filtro seleccionado
      backgroundImageDesktop: backgroundImageDesktop,
      backgroundImageMobile: backgroundImageMobile,
      isMobile: false,
      showVideoGuide: false
    }
  },
  computed: {
    backgroundImage() {
      return this.isMobile ? this.backgroundImageMobile : this.backgroundImageDesktop
    }
  },
  async mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    window.addEventListener('open-video-guide', this.handleOpenVideoGuideEvent)
    await this.loadBannerFromStrapi()
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile)
    window.removeEventListener('open-video-guide', this.handleOpenVideoGuideEvent)
  },
  methods: {
    navigateToBibliografia() {
      window.open('https://bibliografiadigital.aiep.cl/', '_blank')
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    async loadBannerFromStrapi() {
      // Lista de nombres posibles para el tipo de contenido
      const possibleNames = ['hero-banners']
      
      for (const collectionName of possibleNames) {
        try {
          const response = await strapiService.getCollection(collectionName, {
            populate: '*',
            'pagination[limit]': 1,
            sort: 'createdAt:desc'
          })
          
          // Manejar diferentes estructuras de respuesta (Strapi v3 y v4)
          let bannerData = null
          
          // Strapi v4: response.data.data
          if (response.data?.data && Array.isArray(response.data.data) && response.data.data.length > 0) {
            bannerData = response.data.data[0]
          }
          // Strapi v4 alternativo: response.data como array
          else if (response.data && Array.isArray(response.data) && response.data.length > 0) {
            bannerData = response.data[0]
          }
          // Strapi v3: response como array
          else if (Array.isArray(response) && response.length > 0) {
            bannerData = response[0]
          }
          
          if (bannerData) {
            // Extraer atributos según la estructura
            const attributes = bannerData.attributes || bannerData
            
            // Obtener imagen desktop
            if (attributes.imagenDesktop) {
              const desktopUrl = strapiService.getImageUrl(attributes.imagenDesktop)
              if (desktopUrl) {
                this.backgroundImageDesktop = desktopUrl
              }
            }
            
            // Obtener imagen mobile
            if (attributes.imagenMobile) {
              const mobileUrl = strapiService.getImageUrl(attributes.imagenMobile)
              if (mobileUrl) {
                this.backgroundImageMobile = mobileUrl
              }
            }
            
            // Si encontramos datos, salir del loop
            return
          }
        } catch (error) {
          // Si es un 404, probar con el siguiente nombre
          if (error.response && error.response.status === 404) {
            continue
          }
          // Si es otro error, continuar con el siguiente nombre
        }
      }
      
      // Si llegamos aquí, ningún nombre funcionó, usar imágenes por defecto
    },
    handleSearch() {
      const searchTerm = this.searchQuery.trim()

      // Si no hay término de búsqueda, abrir Muse Knowledge directamente
      if (!searchTerm) {
        window.open('https://itms.museknowledge.com/muse/servlet/MusePeer', '_blank')
        return
      }

      // Enviar el formulario POST a Muse Knowledge con el término de búsqueda
      this.$nextTick(() => {
        this.$refs.museForm.submit()
      })
    },
    openVideoGuide() {
      this.showVideoGuide = true
    },
    closeVideoGuide() {
      this.showVideoGuide = false
    }
    ,
    handleOpenVideoGuideEvent() {
      this.openVideoGuide()
    }
  }
}
</script>

<style scoped>
.hero {
  position: relative;
  min-height: 500px;
  padding: 100px 20px 60px;
  overflow: hidden;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 0;
}

.hero-background.has-image {
  background: none;
}

.hero-background::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 51, 102, 0.75) 0%, rgba(0, 102, 204, 0.7) 100%);
  z-index: 1;
}

.hero-background.has-image::after {
  background: #182844A6;
}

@media (max-width: 768px) {
  .hero-background::after {
    background: linear-gradient(135deg, rgba(0, 51, 102, 0.75) 0%, rgba(0, 102, 204, 0.65) 100%);
  }
}

.hero-container {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
}

.hero-content {
  display: grid;
  grid-template-columns: 1fr 1.4fr;
  gap: 15px;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}

.hero-text {
  color: var(--white);
}

.hero-text .btn {
  margin-top: 16px;
  border-radius: 8px;
  font-weight: bold;
  color: #024588;
}

.hero-text .btn svg path {
  fill: #024588;
}

.hero-subtitle {
  font-family: 'Ubuntu', sans-serif;
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  margin-bottom: 0;
  color: #FFFFFF;
}

.hero-title {
  font-family: 'Ubuntu', sans-serif;
  font-size: 45px;
  font-weight: 700;
  font-style: normal;
  margin-bottom: 0;
  margin-top: 0;
  line-height: 1.2;
  flex: 1;
  display: flex;
  align-items: center;
}

.hero-mobile-titles {
  display: none;
}

.hero-widget {
  background: #F8F8F8;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.widget-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 0;
  background: #F8F8F8;
  border-radius: 8px 8px 0 0;
  padding: 8px;
}

.widget-divider {
  width: 100%;
  height: 1px;
  background: var(--border-gray);
  margin: 16px 0;
}

@media (max-width: 768px) {
  .widget-divider {
    width: calc(100% + 48px);
    margin-left: -24px;
    margin-right: -24px;
  }
}

@media (min-width: 769px) {
  .widget-divider {
    height: 1px;
    background: #E0E0E0;
    margin: 0;
  }
}

@media (min-width: 769px) {
  .hero {
    padding: 100px 0 60px;
    min-height: 480px;
  }
  
  .hero-container {
    max-width: 1200px;
    padding: 0 25px;
    width: 100%;
  }
  
  .hero-subtitle {
    white-space: nowrap;
    margin-bottom: 0;
    padding-top: 12px;
  }
  
  .hero-title {
    margin-top: -15px;
    margin-bottom: 0;
  }
  
  .hero-content {
    align-items: flex-start;
    padding-left: 0;
    padding-right: 0;
    min-width: 0;
    gap: 40px;
  }
  
  .hero-text {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 0;
    height: 250px;
  }
  
  .hero-text .btn {
    margin-top: auto;
    align-self: flex-start;
  }
  
  .hero-widget {
    width: 100%;
    max-width: 753px;
    height: auto;
    min-height: 230px;
    padding: 35px 25px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
    margin-top: 18px;
    align-self: flex-start;
  }
  
  .widget-tabs-wrapper {
    display: none;
  }
  
  .widget-divider {
    display: none;
  }
  
  .widget-title {
    padding: 0;
    margin: 0 0 8px 0;
    font-size: 28px;
    color: #024588;
  }
  
  .widget-title-desktop {
    display: inline;
  }
  
  .widget-title-mobile {
    display: none;
  }
  
  .widget-description {
    padding: 0;
    margin: 0 0 24px 0;
    font-size: 16px;
    font-family: Verdana, sans-serif;
    color: #39475F;
  }
  
  .widget-description-desktop {
    display: inline;
  }
  
  .widget-description-mobile {
    display: none;
  }
  
  .search-container {
    padding: 0;
    margin-top: 0;
  }
  
  .search-btn-desktop-svg {
    display: block;
    width: 16px;
    height: 16px;
  }
  
  .floating-btn {
    top: 180px;
  }
}

.tab {
  padding: 10px 20px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--secondary-blue);
  border-radius: 4px;
  font-size: 14px;
  font-family: 'Ubuntu', sans-serif;
  font-weight: 500;
}

.tab.active {
  background: #024588;
  color: var(--white);
  font-weight: 500;
}

.widget-title {
  font-size: 28px;
  color: #024588;
  margin-bottom: 8px;
  margin-top: 10px;
}

.widget-title-desktop {
  display: none;
}

.widget-title-mobile {
  display: inline;
}

.widget-description {
  color: var(--text-light);
  font-size: 16px;
  margin-bottom: 0px;
  font-family: Verdana, sans-serif;
}

.widget-description-desktop {
  display: none;
}

.widget-description-mobile {
  display: inline;
}

.search-container {
  margin-top: 23px;
  display: flex;
  gap: 8px;
  align-items: center;
}

.search-box {
  display: flex;
  gap: 0;
  border: 2px solid #102A8A;
  border-radius: 8px;
  overflow: hidden;
  flex: 1;
}

.search-filter {
  padding: 12px 16px;
  padding-right: 32px;
  border: none;
  border-radius: 0;
  background: #F4F7FFB5;
  color: #102A8A;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  border-right: 2px solid #102A8A;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg%20width%3D%2212%22%20height%3D%227%22%20viewBox%3D%220%200%2012%207%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M4.26332%205.78502V5.77802L0.357318%202.04002C-0.0976821%201.59202%20-0.132682%200.843024%200.336318%200.367024C0.784318%20-0.0879756%201.52632%20-0.129976%202.00932%200.339024L5.60732%203.79002L9.19832%200.332024C9.67432%20-0.129976%2010.4303%20-0.101976%2010.8783%200.367024C11.0953%200.598024%2011.2003%200.899024%2011.2003%201.17902C11.2003%201.48002%2011.0813%201.80202%2010.8363%202.03302L6.96532%205.75002H6.95132C6.15332%206.46402%205.05432%206.47802%204.26332%205.77102V5.78502Z%22%20fill%3D%22%23102A8A%22%2F%3E%3C%2Fsvg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-color: #F4F7FFB5;
}

.search-filter option:first-child {
  color: #102A8A;
}

.search-box .search-filter option:first-child {
  color: #102A8A;
}

.search-filter option:not(:first-child) {
  color: #24334E;
}

.search-filter:focus {
  outline: none;
}

.search-input {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  background: var(--white);
  color: #8B93A1;
}

.search-filter-mobile {
  display: none;
}

.search-input-mobile {
  display: none;
}

.search-input-group {
  display: none;
}

.search-filter-group-mobile {
  display: none;
}

.search-btn-mobile {
  display: none;
}

.search-input::placeholder {
  color: #8B93A1;
}

.search-input:focus {
  outline: none;
}

.search-btn {
  height: 44px;
  padding: 12px 16px;
  background: var(--accent-red);
  color: var(--white);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
}

.search-btn:hover {
  background: #880000;
}

.search-btn-text {
  font-family: 'Ubuntu', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: var(--white);
  white-space: nowrap;
}

.search-btn-desktop-svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.floating-btn {
  position: fixed;
  top: 180px;
  right: 0;
  padding: 12px 20px;
  background: #AA0000;
  color: var(--white);
  border: none;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  z-index: 10;
  font-family: 'Ubuntu', sans-serif;
  font-weight: 500;
  font-size: 13px;
}

.floating-btn-text {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
  text-align: left;
  font-family: 'Ubuntu', sans-serif;
  font-weight: 500;
  font-size: 13px;
}

.floating-btn-text span {
  display: block;
}

.floating-btn:hover {
  background: #990000;
}

@media (max-width: 968px) {
  .hero-content {
    grid-template-columns: 1fr;
  }
  
  .hero-title {
    font-size: 36px;
  }
}

@media (max-width: 768px) {
  .hero {
    padding: 60px 20px 30px;
    min-height: 400px;
    max-height: 440px;
    overflow: hidden;
  }
  
  .hero-text {
    display: none;
  }
  
  .hero-mobile-titles {
    display: block;
    text-align: center;
    color: var(--white);
    margin-bottom: 10px;
    margin-top: 40px;
    position: relative;
    z-index: 1;
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
  }
  
  .hero-mobile-subtitle {
    font-family: 'Ubuntu', sans-serif;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    margin: 0 auto 16px;
    color: #FFFFFF;
    line-height: 1.4;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
  
  .hero-mobile-title {
    font-family: 'Ubuntu', sans-serif;
    font-size: 32px;
    font-weight: 700;
    font-style: normal;
    margin: 0;
    color: #FFFFFF;
    line-height: 1.3;
  }
  
  .hero-widget {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    min-height: auto;
    padding: 24px;
  }
  
  .hero-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  
  .floating-btn {
    position: absolute;
    top: 25px;
    right: 0;
    padding: 8px 12px;
    font-size: 13px;
    border-radius: 4px 0 0 4px;
  }
  
  .floating-btn-text {
    font-size: 13px;
    line-height: 1.3;
  }
  
  .widget-tabs-wrapper {
    display: none;
  }
  
  .widget-divider {
    display: none;
  }
  
  .widget-title {
    display: none;
  }
  
  .widget-description {
    display: none;
  }
  
  .search-container {
    flex-direction: column;
    gap: 12px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    font-size: 14px;
    padding: 0;
    margin-top: 0;
  }
  
  .search-input-group {
    order: 1;
    display: flex;
    gap: 8px;
    width: 100%;
    align-items: stretch;
    box-sizing: border-box;
  }
  
  @media (max-width: 480px) {
    .search-container {
      font-size: 13px;
      gap: 10px;
    }
  }
  
  @media (max-width: 360px) {
    .search-container {
      font-size: 12px;
      gap: 8px;
    }
  }
  
  .search-box {
    display: none;
  }
  
  .search-btn:not(.search-btn-mobile) {
    display: none;
  }
  
  .search-btn-desktop-svg {
    display: none;
  }
  
  .search-input-mobile {
    display: block;
    flex: 1;
    padding: 10px 12px;
    border: 1px solid #024588;
    border-radius: 8px;
    font-size: 1em;
    background: var(--white);
    color: #8B93A1;
    box-sizing: border-box;
    min-height: 44px;
    height: 44px;
    line-height: 1.5;
  }
  
  .search-input-mobile:focus {
    outline: none;
    border-color: #102A8A;
  }
  
  .search-input-mobile::placeholder {
    color: #8B93A1;
    font-size: 1em;
  }
  
  .search-btn-mobile {
    display: flex;
    width: 44px;
    min-width: 44px;
    min-height: 44px;
    height: 44px;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-radius: 8px;
    box-sizing: border-box;
    background: #AA0000;
    color: var(--white);
    border: none;
    cursor: pointer;
    padding: 0;
  }
  
  .search-btn-mobile:hover {
    background: #990000;
  }
  
  .search-btn-mobile svg {
    width: 20px;
    height: 20px;
  }
  
  @media (max-width: 480px) {
    .search-input-mobile {
      min-height: 42px;
      padding: 10px 14px;
      font-size: 14px;
    }
    
    .search-btn-mobile {
      width: 44px;
      min-width: 42px;
      min-height: 42px;
    }
    
    .search-btn-mobile svg {
      width: 18px;
      height: 18px;
    }
  }
  
  @media (max-width: 360px) {
    .search-input-mobile {
      min-height: 40px;
      padding: 8px 12px;
      font-size: 13px;
    }
    
    .search-btn-mobile {
      width: 40px;
      min-width: 40px;
      min-height: 40px;
    }
    
    .search-btn-mobile svg {
      width: 17px;
      height: 17px;
    }
    
    .search-input-group {
      gap: 6px;
    }
  }
}

.video-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.video-modal {
  background: #fff;
  border-radius: 8px;
  width: min(95vw, 800px);
  max-height: 95vh;
  padding: 8px 8px 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

@media (min-width: 1600px) {
  .video-modal {
    width: min(95vw, 800px);
  }
}

.video-modal-close {
  align-self: flex-end;
  border: none;
  background: transparent;
  font-size: 24px;
  cursor: pointer;
}

.video-modal-content {
  flex: 1;
  min-height: 400px;
}

.video-modal-message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 16px;
}

.video-modal-content video {
  width: 100%;
  height: 540px;
  border: none;
}

@media (max-width: 768px) {
  .video-modal-content video {
    height: 400px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>

